import {useContext, useEffect, useState} from 'react'
import {KTIcon} from '../../../../../../_metronic/helpers'
import { DocumentLoadDetailContext } from '../DocumentLoadDetailContext'

const ShowFileModalHeader = () => {
  const {setShowFileModal} = useContext(DocumentLoadDetailContext)
  const [title, setTitle] = useState('')

  useEffect(() => {
    setTitle('Agregar')
  }, [])

  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>Documentos</h2>
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        onClick={() => setShowFileModal(false)}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
    </div>
  )
}

export {ShowFileModalHeader}
